// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__H2T3h","modalFooterButton":"ModalNotes_modalFooterButton__3FBh-"};